import { Box, Group, SimpleGrid, Stack } from '@mantine/core';


function Block({ height, width, }: Readonly<{ height: number; width?: number | string }>) {
  return (
    <Box
      aria-hidden
      h={height}
      bdrs={8}
      w={width ?? '100%'}
      style={{
        background: 'linear-gradient(90deg, var(--text-default) 0%, var(--text-muted) 100%)',
        animation: 'cloudhouse-skeleton-pulse 1.6s ease-in-out infinite',
      }}
    />
  );
}

export function BrandedSkeleton({count = 3}: Readonly<{ count?: number }>) {
  return (
    <Box role="progressbar" aria-label="Loading your Enterprise Hub" aria-busy>
      <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="lg">
        {Array.from({ length: count }).map((_, i) => (
          <Box data-product-tile key={i}
            style={{
              '--product-color': 'var(--text-subtle)',
            }}
          >
            <Stack gap={'sm'} p={24} opacity={.5}>
              <Block height={46} width={46} />

              <Stack gap={3}>
                <Block height={22} width="60%" />
                <Block height={37} />
              </Stack>

              <Block height={1} />

              <Group
                justify="space-between"
                align="center"
                wrap="nowrap"
              >
                <Block height={18} width={100} />
                <Block height={18} width={18} />

              </Group>

            </Stack>
          </Box>
        ))
        }
      </SimpleGrid >
    </Box >
  );
}
